import React from 'react'
import './viewport.scss'

type ViewportProps = {
  className?: string
  id?: string
  size?: 'small' | 'medium' | 'large'
}

const Viewport: React.FC<ViewportProps> = (props) => {
  return (
    <div className={`viewport-wrapper ${props.className}`} id={props.id}>
      <div className={`viewport ${props.size || 'small'}`}>{props.children}</div>
    </div>
  )
}

export default Viewport
